import image from "../../../img/7OHMVp.jpg";
import image2 from "../../../img/7OHMVp1.jpg";

const signupPageStyle = (theme) => ({
  container: {
    display: "flex",
    color: "#FFFFFF",
    width: "100%",
    height: "98vh",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `url(${image})`,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  container1: {
    display: "flex",
    color: "#FFFFFF",
    width: "100%",
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `url(${image2})`,
  },
  buttonStyle: {
    backgroundColor: theme.palette.primary.main,
    width: "50%",
  },

  modalCard: {
    width: "30%",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignItems: "center",
    height: "316px",
  },
  cardDiv: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignItems: "center",
    padding: "30px",
    textAlign: "center",
  },

  modalDiv: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "stretch",
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)",
  },
  root: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  forgetPassword: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  patientLogin: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-start",
  },
  logo: {
    objectFit: "contain",
    maxHeight: "250px",
    maxWidth: "250px",
  },
  textColor: {
    color: "#00a9a9",
  },
  card: {
    width: "55%",
    boxShadow: "0 50px 50px 0 rgba(0,0,0,0.7)",
  },
  card1: {
    width: "65%",
    boxShadow: "0 50px 50px 0 rgba(0,0,0,0.7)",
  },
  pageHeader: {
    minHeight: "100vh",
    color: theme.palette.primary.contrastText,
    height: "auto",
    display: "inherit",
    position: "relative",
    margin: "0",
    padding: "0",
    border: "0",
    alignItems: "center",
    "&:before": {
      background: "rgba(0, 0, 0, 0.5)",
    },
    "&:before,&:after": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
    },
    "& footer li a,& footer li a:hover,& footer li a:active": {
      color: "#FFFFFF",
    },
    "& footer": {
      position: "absolute",
      bottom: "0",
      width: "100%",
    },
  },
  form: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  cardHeader: {
    width: "80%",
    textAlign: "center",
    marginLeft: "20px",
    marginRight: "20px",
    marginTop: "-40px",
    padding: "20px 0",
    marginBottom: "15px",
  },
  socialIcons: {
    maxWidth: "24px",
    marginTop: "0",
    width: "100%",
    transform: "none",
    left: "0",
    top: "0",
    height: "100%",
    lineHeight: "41px",
    fontSize: "20px",
  },
  divider: {
    marginTop: "30px",
    marginBottom: "0px",
    textAlign: "center",
  },
  cardFooter: {
    paddingTop: "0rem",
    border: "0",
    borderRadius: "6px",
    justifyContent: "center !important",
  },
  socialLine: {
    marginTop: "1rem",
    textAlign: "center",
    padding: "0",
  },
  inputIconsColor: {
    color: "#495057",
  },
});

export default signupPageStyle;
